<template>
  <v-card class="table-card elevation-4">
    <v-data-table :headers="column" :items="filteredItems" class="custom-table" v-model:page="page"
      v-model:items-per-page="itemsPerPage" no-data-text="No data found">
      <template #top>
        <v-toolbar flat color="transparent">
          <v-toolbar-title class="white--text title">{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <TextFieldComponent placeholder="Search" v-model="search" class="textFields" />
          <v-btn icon @click="showFilter = !showFilter" class="ml-2">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template #[`item.active`]="{ item }">
        <v-tooltip>
          <template #activator="{ props }">
            <span
              v-bind="props"
              class="radar-dot"
              :class="(item.active == 1 || item.active == 'ACTIVE') ? 'active' : 'inactive'"
            ></span>
          </template>
        
          {{ (item.active == 1 || item.active == 'ACTIVE') ? 'Active' : 'Inactive' }}
        </v-tooltip>
      </template>


      <!-- <template #[`item.active`]="{ item }">
        <div class="status-ribbon" :class="item.active == 1 || item.active == 'ACTIVE'? '' : 'inactive'">
          <div 
            class="ribbon-tag"
            :style="{ background: item.active == 1 || item.active == 'ACTIVE'? '#22c55e' : 'crimson' }"
          >
            {{ item.active == 1 || item.active == 'ACTIVE'? 'ACTIVE' : 'INACTIVE' }}
          </div>
        </div>
      </template> -->

      <template #[`item.modified_name`]="{ item }">
        <span class="text-crimson">
          {{ item.modified_name }}
        </span>
      </template>

      <template #[`item.modified`]="{ item }">
        <span class="text-crimson">
          {{ item.modified ? moment(item.modified).format("DD-MM-YYYY") : '' }}
        </span>
      </template>

      <template #[`item.actions`]="{ item, index }">
        <v-icon v-if="role < 6" small color="#082FB1" size="20" class="mr-5" @click="onEdit(item, 'edit', index)">mdi-pencil</v-icon>
        <v-icon small color="#082FB1" size="20" @click="onView(item, 'view')">mdi-eye</v-icon>
      </template>
    </v-data-table>
  </v-card>
  <FilterDrawer 
    v-model="showFilter"         
    @allSelected="allSelected"
    :headers="headers"
    @filterData="updateSelectedHeaders"
    @editColumns="sendColumns"
  />
</template>

<script>
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import moment from "moment";
import FilterDrawer from "./FilterDrawer.vue";

export default {
  components: { TextFieldComponent, FilterDrawer },
  props: {
    headers: Array,
    dataList: Array,
    title: String,
    role : Number,
  },
  data() {
    return {
      search: "",
      page: 1,
      itemsPerPage: 10,
      showFilter: false,
      column:null,
      finalColumn:null,
      allColumns:null,
      tableHeaders:null
    };
  },
  // created() {
  //       // console.log(this.headers,"9999999")
  //       // console.log(this.dataList,"7777")
  // },
  mounted(){
        this.allColumns = [...this.headers]
        this.column = [...this.headers]
  },
  computed: {
    filteredItems() {
      console.log(this.dataList,"dtdtdtdtdt");
      if(!this.dataList) return []
      const q = this.search.toLowerCase();
      return this.dataList.filter(item =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(q)
        )
      );
    },
  },
  watch: {
    search() {
      this.page = 1;
    },
    itemsPerPage() {
      this.page = 1;
    },
  },
  methods: {
    moment,
    
    // async allSelected(allSelect) {
    //   if (this.allColmuns) {
    //     const newValue = allSelect ? 1 : 0;

    //     this.allColmuns.forEach((column) => {
    //       column.column_required = newValue;
    //     });

    //     await this.getColumns(this.allColmuns);
    //   }
    // },

    async sendColumns(data) {
      const indexToRemove = this.allColumns.findIndex(
        (item) => item.column_name === data.column_name
      );
      if (this.allColumns[indexToRemove].column_required === 1) {
        this.allColumns[indexToRemove].column_required = 0;
      } else {
        this.allColumns[indexToRemove].column_required = 1;
      }
      this.finalColumn = this.allColumns; 
      await this.getColumns(this.finalColumn);
    },
 
    async getColumns(data) {
      if (data) {
        this.column = data.filter((column) => column.column_required);
      } else {
        // if (!this.model) {
        //     this.allColmuns = this.defaultColumns
        //     this.columns = this.allColmuns ? this.allColmuns.filter(column => column.column_required) : '';
        //     console.log(this.columns, 'newcolums');
        // } else {
        //     let res = await ListModelDetailService.getTableColumn({ tableName: this.model });
        //     res = res.data;
        //     this.allColmuns = res
        //     this.columns = this.allColmuns ? this.allColmuns.filter(column => column.column_required) : '';
        //     console.log(this.columns, 'newcolums');
        // }

        // this.allColumns = this.defaultColumns;
        this.column = this.allColumns
          ? this.allColumns.filter((column) => column.column_required)
          : "";

          console.log(this.column,"this.data")
      }
    },

    async allSelected(allSelect) {
      if (this.allColumns) {
        const newValue = allSelect ? 1 : 0;

        this.allColumns.forEach((column) => {
          column.column_required = newValue;
        });

        await this.getColumns(this.allColumns); 
      }
    },
    onView(item, viewType) {
      this.$emit("dialogs", item, true, viewType);
    },
    onEdit(item, viewType, index) {
      this.$emit("dialogs", item, true, viewType, index);
    },
  },
};
</script>


<style scoped>
.text-crimson {
  color: crimson;
}

.textFields {
  margin-top: 24px;
  margin-right: 14px;
}

.table-card {
  border-radius: 12px;
}

>>>.custom-table th:last-child,

>>>.custom-table td:last-child {

  position: sticky !important;
  right: 0 !important;
  z-index: 10 !important;
  min-width: 120px !important;
  /* display: flex;
    align-items: center;
    gap: 12px; */

}

>>>.custom-table tr:nth-child(even) td:last-child {
  background-color: #f6f6ff !important;
}

>>>.custom-table tr:nth-child(odd) td:last-child {
  background-color: #FFFFFF !important;
}

>>>.custom-table tr:nth-child(even) td:last-child:hover {
  background-color: #c9c9ca !important;
  /* transition: background 0.3s !important;     */
}

>>>.custom-table tr:nth-child(odd) td:last-child:hover {
  background-color: #c9c9ca !important;
  /* transition: background 0.3s !important;     */
}


::v-deep(.custom-table thead th) {
  /* min-width: 250px; */
  /* max-width: 500px; */
  background-color: #e2e2fc !important;
  color: #000000 !important;
  font-weight: 600 !important;
  font-size: 18px;
}

::v-deep(.custom-table tbody tr:nth-child(even)) {
  background-color: #f6f6ff;
}

::v-deep(.custom-table tbody tr:hover) {
  background-color: #c9c9ca;
  transition: background 0.3s;
}

::v-deep(.custom-table tbody td) {
  font-weight: 500;
  font-size: 15px;
  /* min-width: 250px; */
  /* max-width: 500px; */
}

.title {
  font-weight: 500;
}

.custom-table td {
  width: 600px;
}

.status-ribbon {
  position: relative;
  width: 70px;
  height: 40px;
}

.status-ribbon .ribbon-tag {
  position: absolute;
  top: 8px;
  left: -3px;
  width: 70px;
  color: white;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 0;
}
.radar-dot {
  width: 15px;
  height: 15px;
  left: 15px;
  border-radius: 50%;
  position: relative;
  display: inline-block;
}

.radar-dot.active {
  background-color: #22c55e;
}

.radar-dot.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: rgba(34, 197, 94, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: radarPulseGreen 0.5s infinite ease-out;
}

.radar-dot.inactive {
  background-color: crimson;
}

.radar-dot.inactive::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: rgba(220, 20, 60, 0.5);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: radarPulseRed 2s infinite ease-out;
}

@keyframes radarPulseGreen {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  100% {
    transform: translate(-50%, -50%) scale(4.2); 
    opacity: 0;
  }
}

@keyframes radarPulseRed {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }
  100% {
    transform: translate(-50%, -50%) scale(3.6); 
    opacity: 0;
  }
}

</style>